import { createSlice } from '@reduxjs/toolkit'

import { getJobsList } from '@/containers/Dashboard/CountriesSummary/thunk'

const initialState = {
  jobsList: [],
  isJobsListLoading: false,
  isJobsListError: false
}

const countriesSummarySlice = createSlice({
  name: 'countriesSummary',
  initialState,
  extraReducers: {
    [getJobsList.pending]: (state) => {
      state.isJobsListError = false
      state.isJobsListLoading = true
    },
    [getJobsList.fulfilled]: (state, action) => {
      state.isJobsListError = false
      state.isJobsListLoading = false
      state.jobsList = action.payload
    },
    [getJobsList.rejected]: (state) => {
      state.isJobsListError = true
      state.isJobsListLoading = false
    }
  }
})

const { reducer } = countriesSummarySlice

export default reducer
